import { render } from "./TreeSelectionProducts.vue?vue&type=template&id=13002b2c&scoped=true&ts=true"
import script from "./TreeSelectionProducts.vue?vue&type=script&lang=ts"
export * from "./TreeSelectionProducts.vue?vue&type=script&lang=ts"

import "./TreeSelectionProducts.vue?vue&type=style&index=0&id=13002b2c&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13002b2c"]])

export default __exports__